import { ArrowDownUp } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

/**
 * Reusable sort dropdown for listing pages.
 * options = [{ value: "az", label: "A → Z" }, ...]
 */
export const SortFilter = ({ value, onChange, options, testId = "sort-filter", label = "Ordenar" }) => {
  return (
    <div className="flex items-center gap-3">
      <span className="hidden sm:flex items-center gap-2 text-[11px] tracking-[0.3em] uppercase text-[#C6A762]">
        <ArrowDownUp size={13} /> {label}
      </span>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          data-testid={testId}
          className="w-full sm:w-[220px] h-11 bg-[#141414] border-[#262626] text-white/90 text-sm rounded-lg focus:ring-[#C6A762]/40 hover:border-[#C6A762]/50 transition-colors"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-[#141414] border-[#262626] text-white/90">
          {options.map((o) => (
            <SelectItem key={o.value} value={o.value} data-testid={`${testId}-option-${o.value}`}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default SortFilter;
